'use client';

import { withFetchData } from '../../components/with-fetch-data';
import { composeHoc } from '../../../utils/compose';
import { BaseChart } from '../../components/base-chart';
import { withContainer } from '../../components/container';
import { withLoading } from '../../components/with-loading/loading';
import { IChartProps } from '../../interface';

export const CardChart: React.FC<IChartProps> = composeHoc(
  withContainer,
  withLoading,
  withFetchData
)(BaseChart);

export default CardChart;
